import { Box, Button, Flex, HStack, Spinner, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import MainPageSectionBrands from "../components/MainPageSections/MainPageSectionBrands";
import apiClient from "../utils/apiClient";

const BrandsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [brandsLoaded, setBrandsLoaded] = useState(false);
  const [brands, setBrands] = useState([]);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        setIsLoading(true);
        const response = await apiClient.get("/brands", {
          params: {
            per_page: 24,
            page,
          },
        });

        const payload = response.data?.response;
        const items = payload?.data || [];

        const sections = [
          {
            title: "Ammo brands",
            description:
              "Browse ammunition brands available on BulletScout and explore their products.",
            logos: items.map((brand) => {
              let slug = "";
              try {
                const url = new URL(brand.url);
                slug = url.pathname.replace(/^\/|\/$/g, "");
              } catch (e) {
                slug = brand.url.split("/").filter(Boolean).pop() || "";
              }

              return {
                link: brand.brand_name === 'Aguila' ? `/brands/${slug}` : undefined,
                white: brand.brand_image_w,
                black: brand.brand_image_b,
              };
            }),
          },
        ];

        setBrands(sections);
        setLastPage(payload?.last_page || 1);
        setBrandsLoaded(true);
      } catch (error) {
        console.error("Error fetching brands list: ", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBrands();
  }, [page]);

  return (
    <Box pt="60px">
      <Helmet>
        <title>Ammo brands | BulletScout</title>
        <meta
          name="description"
          content="Browse ammo brands available on BulletScout."
        />
      </Helmet>

      {isLoading && (
        <Flex justify="center" mt={10} mb={6}>
          <Spinner size="lg" thickness="3px" speed="0.6s" />
        </Flex>
      )}

      {!isLoading && brandsLoaded && (
        <MainPageSectionBrands sections={brands} />
      )}

      {lastPage > 1 && (
        <Flex justify="center" mt={8} mb={10}>
          <HStack spacing={4}>
            <Button
              size="sm"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              isDisabled={page === 1 || isLoading}
            >
              Previous
            </Button>
            <Text fontSize="sm">
              Page {page} of {lastPage}
            </Text>
            <Button
              size="sm"
              onClick={() => setPage((p) => Math.min(lastPage, p + 1))}
              isDisabled={page === lastPage || isLoading}
            >
              Next
            </Button>
          </HStack>
        </Flex>
      )}
    </Box>
  );
};

export default BrandsPage;


